import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CenterPanel from './centerPanel';
import RightPanel from './rightPanel';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import Info from '../../info';
import { useStringValidation } from 'businessLogic/helperHooks';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';

// There are shared states and function between center panel and right panel
function CenterAndRightPanelComponent(props) {
  const [canEditMessages, setCanEditMessages] = useState(props.orgUnitShareLinkForWAForm.staffCanEditMessages);
  const [additionalEmailMessage, setAdditionalEmailMessage] = useState(
    props.orgUnitShareLinkForWAForm.additionalEmailMessage
  );
  const [additionalTextMessage, setAdditionalTextMessage] = useState(
    props.orgUnitShareLinkForWAForm.additionalTextMessage
  );

  const textMessageCharacterLimit = 100;
  const emailMessageCharacterLimit = 255;

  const emailMessageValidState = useStringValidation({
    checkCharacterLimt: true,
    characterLimt: emailMessageCharacterLimit,
    checkASCII: true,
    str: additionalEmailMessage,
  });

  const textMessageValidState = useStringValidation({
    checkCharacterLimt: true,
    characterLimt: textMessageCharacterLimit,
    checkASCII: true,
    str: additionalTextMessage,
  });

  return (
    <React.Fragment>
      <div className="content body-content">
        <div className="main-ui-container">
          <div id="righthandfloatingpanel" style={{ minHeight: '400px' }}>
            <div className="right ui rail">
              <div className="ui sticky">
                <RightPanel
                  canEditMessages={canEditMessages}
                  additionalEmailMessage={additionalEmailMessage}
                  additionalTextMessage={additionalTextMessage}
                  networkId={props.networkId}
                  textMessageValidState={textMessageValidState}
                  emailMessageValidState={emailMessageValidState}
                />
              </div>
            </div>
            <CenterPanel
              originalMessage={props.orgUnitShareLinkForWAForm.message}
              lockStaffCanEditFunction={props.orgUnitShareLinkForWAForm.lockStaffCanEditFunction}
              canEditMessages={canEditMessages}
              setCanEditMessages={setCanEditMessages}
              additionalEmailMessage={additionalEmailMessage}
              setAdditionalEmailMessage={setAdditionalEmailMessage}
              additionalTextMessage={additionalTextMessage}
              setAdditionalTextMessage={setAdditionalTextMessage}
              textMessageCharacterLimit={textMessageCharacterLimit}
              emailMessageCharacterLimit={emailMessageCharacterLimit}
              textMessageValidState={textMessageValidState}
              emailMessageValidState={emailMessageValidState}
            />
            <div className="bottom-rail-with-left-and-right-content mrtl">
              <div className="mrtm">
                <Info
                  paragraphs={[
                    APP.LANGUAGE.ShareLinkSharedText.InfoText1,
                    APP.LANGUAGE.OrgUnitShareLinkforWA.InfoText2,
                    APP.LANGUAGE.OrgUnitShareLinkforWA.InfoText3,
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-rail-with-left-and-right-content mrtnull">
        <RightPanel
          canEditMessages={canEditMessages}
          additionalEmailMessage={additionalEmailMessage}
          additionalTextMessage={additionalTextMessage}
          networkId={props.networkId}
          textMessageValidState={textMessageValidState}
          emailMessageValidState={emailMessageValidState}
        />
      </div>
    </React.Fragment>
  );
}

function OrgUnitShareLinkWAModalContent(props) {
  let orgName = props.selectedOrgUnit ? props.selectedOrgUnit.name : '';
  const orgUnitShareLinkForWAForm = useSelector((state) => state.organisationsReducer.orgUnitShareLinkForWAForm);

  return (
    <Modal show={true} hideWhenClickAway={false} className="share-wa-link fixed-header-footer-mobile">
      <PopupHeader
        title={APP.LANGUAGE.OrgUnitShareLinkforWA.Title}
        subtitle={orgName}
        helpLink={APP.EXTERNAL_LINKS.OrgUnit.HelpShareWALink}
      />
      <Container fluid as={Media} at="mobile" className="content-container">
        <div className="bold title-sms text-size-l mrtl mrbs">{APP.LANGUAGE.ShareLinkSharedText.Header}</div>
        <hr className="mrtnull" style={{ border: '1px solid #e6e6e6' }} />
      </Container>
      <CenterAndRightPanelComponent
        networkId={props.selectedOrgUnit.networkId}
        orgUnitShareLinkForWAForm={orgUnitShareLinkForWAForm}
      />
    </Modal>
  );
}

export default OrgUnitShareLinkWAModalContent;
